import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
type keyValue = {
  key: string | number,
  value: string | number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'selectBox',
  props: {
    label: { default: '' },
    items: {},
    modelValue: {},
    clearable: { type: Boolean, default: true }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, _mergeProps({
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: props.label,
    items: props.items,
    "item-value": "value",
    "item-title": "key",
    "hide-details": "auto",
    class: "select-box"
  }, {'return-object': true}, {
    clearable: props.clearable
  }), null, 16, ["modelValue", "label", "items", "clearable"]))
}
}

})